module.exports = {"210123001":"北三家子街道","210123002":"胜利街道","210123003":"东关街道","210123101":"小城子镇","210123102":"张强镇","210123103":"方家屯镇","210123105":"郝官屯镇","210123106":"二牛所口镇","210123203":"北四家子乡","210123204":"两家子乡","210123206":"海洲窝堡乡","210123208":"沙金台蒙古族满族乡","210123209":"柳树屯蒙古族满族乡","210123210":"西关屯蒙古族满族乡","210123211":"东升满族蒙古族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210123.json
// module id = 511
// module chunks = 0